import { ExpandMore } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, Chip, Grid, Tooltip, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { FormAutocomplete, FormTextField } from "../../../../../../../components/fields";
import { IFormValues } from "../../../../../types";

const MainDetails = () => {

    const { t } = useTranslation('booking');

    return (
        <Accordion defaultExpanded>
            <AccordionSummary expandIcon={<ExpandMore />}
                              sx={{
                                  '.MuiAccordionSummary-content': {
                                      justifyContent: "space-between",
                                      alignItems: "center"
                                  }
                              }}
            >
                <Typography variant="h5">
                    {t('label.mainDetails')}
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container rowSpacing={1} columnSpacing={3}>
                    <Grid item xs={12} sm={6}>
                        <FormTextField<IFormValues>
                            name="mainDetails.pickupLocation"
                            label={t('label.pickupLocation')}
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormTextField<IFormValues>
                            name="mainDetails.dropoffLocation"
                            label={t('label.dropoffLocation')}
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormTextField<IFormValues>
                            name="mainDetails.pickupDate"
                            label={t('label.pickupDate')}
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormTextField<IFormValues>
                            name="mainDetails.dropoffDate"
                            label={t('label.dropoffDate')}
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormTextField<IFormValues>
                            name="mainDetails.pickupTime"
                            label={t('label.pickupTime')}
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormTextField<IFormValues>
                            name="mainDetails.dropoffTime"
                            label={t('label.dropoffTime')}
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormTextField<IFormValues>
                            name="mainDetails.totalRentalDays"
                            label={t('label.totalRentalDays')}
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormTextField<IFormValues>
                            name="mainDetails.bookedVehicleType"
                            label={t('label.bookedVehicleType')}
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormTextField<IFormValues>
                            name="mainDetails.bookedCarGroup"
                            label={t('label.bookedCarGroup')}
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormTextField<IFormValues>
                            name="mainDetails.carGroupModels"
                            label={t('label.carGroupModels')}
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormTextField<IFormValues>
                            name="mainDetails.mileageIncluded"
                            label={t('label.mileageIncluded')}
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormAutocomplete<IFormValues>
                            name="mainDetails.ancillaries"
                            label={t('label.ancillaries')}
                            options={[]}
                            multiple
                            readOnly
                            textFieldProps={{
                                InputLabelProps: {
                                    shrink: true
                                }
                            }}
                            renderTags={(tagValue, getTagProps) => 
                                tagValue.map((option, index) => (
                                    <Tooltip title={option.sellType == "D" ? t("tooltip.toBePaidAtDesk") : ''} arrow key={option.label}>
                                        <Chip
                                            label={`${option.sellType == "D" ? t("prefix.desk") : ''}${option.label}`}
                                            {...getTagProps({index})}
                                            color={option.sellType == "D" ?  "warning" : undefined}
                                        />
                                    </Tooltip>
                                ))
                            }
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormTextField<IFormValues>
                            name="mainDetails.deliveryState"
                            label={t('label.deliveryState')}
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormTextField<IFormValues>
                            name="mainDetails.deliveryPostalCode"
                            label={t('label.deliveryPostalCode')}
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormTextField<IFormValues>
                            name="mainDetails.deliveryCity"
                            label={t('label.deliveryCity')}
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormTextField<IFormValues>
                            name="mainDetails.deliveryStreetName"
                            label={t('label.deliveryStreetName')}
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormTextField<IFormValues>
                            name="mainDetails.deliveryStreetNumber"
                            label={t('label.deliveryStreetNumber')}
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormTextField<IFormValues>
                            name="mainDetails.collectionState"
                            label={t('label.collectionState')}
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormTextField<IFormValues>
                            name="mainDetails.collectionPostalCode"
                            label={t('label.collectionPostalCode')}
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormTextField<IFormValues>
                            name="mainDetails.collectionCity"
                            label={t('label.collectionCity')}
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormTextField<IFormValues>
                            name="mainDetails.collectionStreetName"
                            label={t('label.collectionStreetName')}
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormTextField<IFormValues>
                            name="mainDetails.collectionStreetNumber"
                            label={t('label.collectionStreetNumber')}
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    )
};

export default MainDetails;
